// Create-submission autofill (LAM-4379). Mirrors the backend's AutofillPollStatus and
// AutofillConfidence in portal/logic/orchestrator/integration_processors/
// create_submission_autofill_processor.py — keep both sides in step.

// Job state as reported by GET /api/orderinfo/submission/<key>/autofill/.
// IDLE is frontend-only: no run has been started (or the last one is finished with).
export const AUTOFILL_STATUS = {
  IDLE: "",
  NONE: "none",
  QUEUED: "queued",
  PROCESSING: "processing",
  DONE: "done",
  ERROR: "error",
};

// How sure the model was about a candidate value.
export const AUTOFILL_CONFIDENCE = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
};

export const AUTOFILL_CONFIDENCE_ICONS = {
  [AUTOFILL_CONFIDENCE.HIGH]: "mdi-check-circle-outline",
  [AUTOFILL_CONFIDENCE.MEDIUM]: "mdi-circle-outline",
  [AUTOFILL_CONFIDENCE.LOW]: "mdi-help-circle-outline",
};

export const autofillConfidenceIcon = (confidence) =>
  AUTOFILL_CONFIDENCE_ICONS[confidence] || AUTOFILL_CONFIDENCE_ICONS[AUTOFILL_CONFIDENCE.MEDIUM];

// Matched to the backend scheduler passes, which dispatch and collect on their own 3s beats.
// A slower poll here would put the run's finish back behind a wait the server no longer has.
export const AUTOFILL_POLL_INTERVAL_MS = 3 * 1000;
export const AUTOFILL_POLL_TIMEOUT_MS = 5 * 60 * 1000;
// A run takes minutes and is polled every few seconds, so it only takes one unlucky request for a
// finished extraction to be reported to the user as a failure. Consecutive failures are what
// indicate a real problem; a single blip is not worth discarding the run over.
export const AUTOFILL_POLL_MAX_CONSECUTIVE_FAILURES = 3;

// Mirrors MAX_DOCUMENTS_PER_RUN in portal/logic/ai/create_submission_autofill.py. That cap
// covers the submission's own documents plus any extra uploads together, and the
// worker silently truncates past it — so the UI warns before the run rather than after.
export const AUTOFILL_MAX_DOCUMENTS_PER_RUN = 15;

// Diagnoses arrive as (name, icd10Code) pairs in their own list rather than as form fields,
// because an order carries one primary diagnosis plus any number of secondary ones. Each
// candidate can therefore be applied to either slot.
export const AUTOFILL_DIAGNOSIS_SLOT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
};
